import { WebStorageStateStore } from "oidc-client-ts";
import { AuthProviderProps } from "react-oidc-context";

export const oidcStorage = window.localStorage;

export const oidcConfig: AuthProviderProps = {
  authority: import.meta.env.VITE_AUTHORITY,
  client_id: import.meta.env.VITE_CLIENT_ID,
  extraQueryParams: {
    audience: import.meta.env.VITE_AUDIENCE,
  },
  redirect_uri: window.location.origin.toString(),
  scope: "openid offline_access email",
  userStore: new WebStorageStateStore({ store: oidcStorage }),
};
